/**
 * Overlay de linhas guias sobre o canvas do editor.
 *
 * Renderizado como elementos DOM absolutamente posicionados — **fora** do Fabric canvas —
 * portanto não é capturado por `getPreviewDataUrl()` nem serializado no JSON do slide.
 *
 * Exibe linhas de centro (50%) e de terços (33.33% / 66.67%) para ambos
 * os dispositivos (desktop e mobile) sem lógica condicional, pois usa `%`.
 */
export interface CanvasGuidesProps {
  readonly visible: boolean;
  readonly isMobile: boolean;
}

export function CanvasGuides({ visible, isMobile }: CanvasGuidesProps) {
  if (!visible) return null;

  return (
    <div className="pointer-events-none absolute inset-none z-10" aria-hidden="true">
      {/* ── Horizontal center ── */}
      <div
        className="absolute left-none right-none h-none border-t-hairline border-dashed border-base-neutral-white opacity-opaque"
        style={{ top: '50%' }}
      />

      {/* ── Vertical center ── */}
      <div
        className="absolute bottom-none top-none w-none border-l-hairline border-dashed border-base-neutral-white opacity-opaque"
        style={{ left: '50%' }}
      />

      {/* ── Horizontal thirds ── */}
      <div
        className="absolute left-none right-none h-none border-t-hairline border-dashed border-base-neutral-white"
        style={{ top: isMobile ? '16px' : '32px' }}
      />
      <div
        className="absolute left-none right-none h-none border-t-hairline border-dashed border-base-neutral-white"
        style={{ bottom: isMobile ? '16px' : '32px' }}
      />

      {/* ── Vertical thirds ── */}
      <div
        className="absolute bottom-none top-none w-none border-l-hairline border-dashed border-base-neutral-white"
        style={{ left: isMobile ? '16px' : '32px' }}
      />
      <div
        className="absolute bottom-none top-none w-none border-l-hairline border-dashed border-base-neutral-white"
        style={{ right: isMobile ? '16px' : '32px' }}
      />
    </div>
  );
}
